import React from 'react'

const Education = () => {
  return (
    <div>
      <h2> I have collection of "E-commerce", "Education", "Healthcare & Medical", "Nutrition", "Financial", "Steel Manufacturing", "Electornics & CDIT", "Fashion & Lifestyle", "Travel & Hospitality", "Life Sciences", "Legal", "Pets & Animalcare", "Non-Profit & Charity",  "Transportation & Logistics" </h2>
      
    </div>
  )
}

export default Education
